import Navbar from "@/components/Navbar";
import Configurator from "@/components/Configurator";
import Footer from "@/components/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function ConfiguratorPage() {
  return (
      <div className="relative min-h-screen bg-brand-bone" data-testid="configurator-page">
        <Navbar />
        <div className="pt-28 md:pt-32">
          <Configurator />
        </div>
        <Footer />
        <ChatWidget />
      </div>
  );
}
